module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAUCAIAAAD3FQHqAAAAIUlEQVQ4y2M4J6hGLcQwataoWUPFrP/UA6NmjZo1VMwCACKr6iIzH0CeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/mc.png
// module id = 333
// module chunks = 0